import { createAction } from 'redux-actions';

import * as actionTypes from './actionTypes';

export const updateOutdatedState = createAction(actionTypes.UPDATE_OUTDATED_STATE, (newState: boolean) => newState);
export const updateViewType = createAction(actionTypes.UPDATE_VIEW_TYPE, (newType: string) => newType);

// routing
export const updateLastRoute = createAction(actionTypes.UPDATE_LAST_ROUTE, (lastRoute: string) => lastRoute);
export const updateAttemptedRoute = createAction(
  actionTypes.UPDATE_LAST_ATTEMPTED_ROUTE,
  (lastAttemptedRoute: RouteState) => lastAttemptedRoute,
);
